<template>

  <div>
    <div class="loader d-flex align-center justify-center" v-if="!condition">
      <v-progress-circular indeterminate color="primary" size="50" width="3"></v-progress-circular>
    </div>

    <slot v-if="condition"></slot>
  </div>

</template>

<script>

  export default {
    name: 'loader',

    props: [ 'condition', 'invisible' ]
  }

</script>

<style scoped lang="scss">

  .loader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

</style>
